import { render, staticRenderFns } from "./clearCache.vue?vue&type=template&id=4894e90a&scoped=true"
import script from "./clearCache.vue?vue&type=script&lang=js"
export * from "./clearCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894e90a",
  null
  
)

export default component.exports